import ReactDOM from "react-dom/client";
import { Router } from "routing";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(<Router />);
